<ul class="nav nav-pills m-b-10">
  @for (section of downloadSections; track section) {
    <li class="nav-item">
      <a class="nav-link" tabindex="0" (keyup.enter)="displayDownloadSection(section)" (click)="displayDownloadSection(section)" [class.active]="section.displayed">
        {{ "download." + section.value | translate }}
      </a>
    </li>
  }
</ul>
<div class="grid-container pad-10">
  @for (dl of downloads[displayedDownloadSection.value]; track dl) {
    @if ((hideOtherLanguageDocs && dl.isMyLanguage) || !hideOtherLanguageDocs) {
      <myp-download-tile [dealer]="dealer" [product]="product" [product_id]="product.id" [download]="dl"></myp-download-tile>
    }
  }
</div>

<div class="m-t-10 t-12">
  <button class="small-btn" (click)="hideOtherLanguageDocs = !hideOtherLanguageDocs">Show {{ hideOtherLanguageDocs ? "All Languages" : helperService.selectedLanguage.name }}</button>
</div>
